import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var _excluded = ["jobPositionId", "restaurantId", "workerId", "id", "limit", "offset", "status_key", "last_status_change", "show_worker_distance", "hidden", "spontaneous_applications", "search_vector"],
    _excluded2 = ["jobPositionId", "limit", "offset", "status_key", "show_worker_distance", "spontaneous_applications", "search_vector", "hidden", "restaurantId", "queryFor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ENDPOINTS } from './../../endpoints';
import { useMemo } from 'react';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import useServices from '../../hooks/useServices';
import { indexJobApplicationsEmployerJPPageQuery, indexJobApplicationsLABQuery, workerShortlistNotesQuery } from './graphqlQueries';

var ServiceWorkerJobPositions = /*#__PURE__*/function (_Service) {
  _inherits(ServiceWorkerJobPositions, _Service);

  var _super = _createSuper(ServiceWorkerJobPositions);

  function ServiceWorkerJobPositions() {
    _classCallCheck(this, ServiceWorkerJobPositions);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceWorkerJobPositions, [{
    key: "fetchWorkerTimeline",
    value: function fetchWorkerTimeline(_ref) {
      var workerId = _ref.workerId,
          jobPositionId = _ref.jobPositionId;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.workerStatus, {
        params: {
          worker_id: workerId,
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "fetchShortlists",
    value: function fetchShortlists(_ref2) {
      var limit = _ref2.limit,
          offset = _ref2.offset,
          jobPositionId = _ref2.jobPositionId,
          statusKey = _ref2.statusKey,
          useCache = _ref2.useCache;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.shortlists, {
        params: {
          limit: limit,
          offset: offset,
          job_position_id: jobPositionId,
          status_key: statusKey
        },
        headers: {
          useCache: !!useCache
        }
      });
    }
  }, {
    key: "sendShortlist",
    value: function sendShortlist(shortlistId) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.sendShortlist, {
        shortlist_id: shortlistId
      });
    }
  }, {
    key: "cleanPendingApplications",
    value: function cleanPendingApplications(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.cleanPendingApplications, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "createJobApplication",
    value: function createJobApplication(_ref3) {
      var jobPositionId = _ref3.jobPositionId,
          workerId = _ref3.workerId,
          statusKey = _ref3.statusKey,
          source = _ref3.source,
          params = _ref3.params;
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.jobApplication, _objectSpread({
        job_position_id: jobPositionId,
        worker_id: workerId,
        status_key: statusKey,
        source: source
      }, params));
    }
  }, {
    key: "updateJobApplication",
    value: function updateJobApplication(_ref4) {
      var jobPositionId = _ref4.jobPositionId,
          workerId = _ref4.workerId,
          restaurantId = _ref4.restaurantId,
          params = _ref4.params;
      return this.axiosInstance.patch(ENDPOINTS.workerJobPositions.jobApplication, _objectSpread({
        job_position_id: jobPositionId,
        worker_id: workerId,
        restaurant_id: restaurantId
      }, params));
    }
  }, {
    key: "addWorkerToShortlist",
    value: function addWorkerToShortlist(_ref5) {
      var shortlistId = _ref5.shortlistId,
          workerId = _ref5.workerId,
          comment = _ref5.comment,
          candidateHighlights = _ref5.candidateHighlights;
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.addWorkerToShortlist, {
        shortlist_id: shortlistId,
        worker_id: workerId,
        notes: comment,
        candidate_highlights: candidateHighlights
      });
    }
  }, {
    key: "deleteWorkerFromShortlist",
    value: function deleteWorkerFromShortlist(_ref6) {
      var shortlistId = _ref6.shortlistId,
          workerId = _ref6.workerId;
      return this.axiosInstance["delete"](ENDPOINTS.workerJobPositions.removeWorkerFromShortlist, {
        data: {
          shortlist_id: shortlistId,
          worker_id: workerId
        }
      });
    }
  }, {
    key: "updateWorkerShortlist",
    value: function updateWorkerShortlist(_ref7) {
      var shortlistId = _ref7.shortlistId,
          workerId = _ref7.workerId,
          comment = _ref7.comment;
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.updateWorkerShortlist, {
        shortlist_id: shortlistId,
        worker_id: workerId,
        notes: comment
      });
    }
  }, {
    key: "createShortlist",
    value: function createShortlist(_ref8) {
      var jobPositionId = _ref8.jobPositionId,
          workerId = _ref8.workerId,
          comment = _ref8.comment,
          candidateHighlights = _ref8.candidateHighlights;
      var workers = [];

      if (workerId) {
        workers = [{
          worker_id: workerId,
          notes: comment,
          candidate_highlights: candidateHighlights
        }];
      }

      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.shortlist, {
        job_position_id: jobPositionId,
        workers: workers
      });
    }
  }, {
    key: "deleteShortlist",
    value: function deleteShortlist(shortlistId) {
      return this.axiosInstance["delete"](ENDPOINTS.workerJobPositions.shortlist, {
        data: {
          id: shortlistId
        }
      });
    } // send request with either status_key or sentiment

  }, {
    key: "fetchWorkerJobPositions",
    value: function fetchWorkerJobPositions(_ref9) {
      var limit = _ref9.limit,
          offset = _ref9.offset,
          status_key = _ref9.status_key,
          sentiment = _ref9.sentiment;
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.jobPosition), {
        params: {
          limit: limit,
          offset: offset,
          status_key: status_key,
          sentiment: sentiment
        }
      });
    }
  }, {
    key: "getCompatibilityScore",
    value: function getCompatibilityScore(_ref10) {
      var workerId = _ref10.workerId,
          jobPositionId = _ref10.jobPositionId;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.getCompatibilityScore, {
        params: {
          worker_id: workerId,
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "jobApply",
    value: function jobApply(data) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.workerApply, data);
    }
  }, {
    key: "jobApplyStatus",
    value: function jobApplyStatus(params) {
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.jobApplyStatus, {
        params: params
      });
    }
  }, {
    key: "fetchWorkerShortlistNotes",
    value: function fetchWorkerShortlistNotes(workerId) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.graphql, {
        query: workerShortlistNotesQuery,
        variables: {
          worker_id: workerId
        }
      });
    }
  }, {
    key: "listSpontaneousApplications",
    value: function listSpontaneousApplications(_ref11) {
      var worker_id = _ref11.worker_id,
          restaurant_id = _ref11.restaurant_id;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.listSpontaneousApplications, {
        params: {
          worker_id: worker_id,
          restaurant_id: restaurant_id
        }
      });
    }
  }, {
    key: "showSpontaneousApplication",
    value: function showSpontaneousApplication(_ref12) {
      var worker_id = _ref12.worker_id,
          restaurant_id = _ref12.restaurant_id;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.spontaneousApplication, {
        params: {
          worker_id: worker_id,
          restaurant_id: restaurant_id
        }
      });
    }
  }, {
    key: "listWorkerJobApplicationsHistory",
    value: function listWorkerJobApplicationsHistory(_ref13) {
      var jobPositionId = _ref13.jobPositionId,
          restaurantId = _ref13.restaurantId,
          id = _ref13.id,
          workerId = _ref13.workerId;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.jobApplicationsHistory, {
        params: {
          job_position_id: jobPositionId,
          restaurant_id: restaurantId,
          id: id,
          worker_id: workerId
        }
      });
    }
  }, {
    key: "indexJobApplications",
    value: function indexJobApplications(_ref14) {
      var jobPositionId = _ref14.jobPositionId,
          restaurantId = _ref14.restaurantId,
          workerId = _ref14.workerId,
          id = _ref14.id,
          limit = _ref14.limit,
          offset = _ref14.offset,
          status_key = _ref14.status_key,
          last_status_change = _ref14.last_status_change,
          show_worker_distance = _ref14.show_worker_distance,
          hidden = _ref14.hidden,
          spontaneous_applications = _ref14.spontaneous_applications,
          search_vector = _ref14.search_vector,
          rest = _objectWithoutProperties(_ref14, _excluded);

      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.jobApplications, {
        params: _objectSpread({
          worker_id: workerId,
          job_position_id: jobPositionId,
          restaurant_id: restaurantId,
          id: id,
          limit: limit,
          offset: offset,
          status_key: status_key,
          last_status_change: last_status_change,
          show_worker_distance: show_worker_distance,
          hidden: hidden,
          spontaneous_applications: spontaneous_applications,
          search_vector: search_vector
        }, rest)
      });
    }
  }, {
    key: "indexJobApplicationsGraphql",
    value: function indexJobApplicationsGraphql(_ref15) {
      var jobPositionId = _ref15.jobPositionId,
          limit = _ref15.limit,
          offset = _ref15.offset,
          status_key = _ref15.status_key,
          show_worker_distance = _ref15.show_worker_distance,
          spontaneous_applications = _ref15.spontaneous_applications,
          search_vector = _ref15.search_vector,
          hidden = _ref15.hidden,
          restaurantId = _ref15.restaurantId,
          queryFor = _ref15.queryFor,
          rest = _objectWithoutProperties(_ref15, _excluded2);

      var graphqlQuery;

      switch (queryFor) {
        case 'LAB':
          graphqlQuery = indexJobApplicationsLABQuery;
          break;

        case 'employers-JP-Page':
          graphqlQuery = indexJobApplicationsEmployerJPPageQuery;
          break;

        default:
          graphqlQuery = indexJobApplicationsEmployerJPPageQuery;
      }

      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.graphql, {
        query: graphqlQuery,
        variables: _objectSpread({
          job_position_id: jobPositionId,
          limit: limit,
          offset: offset,
          status_key: status_key,
          show_worker_distance: show_worker_distance,
          spontaneous_applications: spontaneous_applications,
          search_vector: search_vector,
          hidden: hidden,
          restaurant_id: restaurantId
        }, rest)
      });
    }
  }, {
    key: "showJobApplication",
    value: function showJobApplication(_ref16) {
      var id = _ref16.id,
          jobPositionId = _ref16.jobPositionId,
          workerId = _ref16.workerId;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.jobApplication, {
        params: {
          id: id,
          job_position_id: jobPositionId,
          worker_id: workerId
        }
      });
    }
  }, {
    key: "fetchConversationSteps",
    value: function fetchConversationSteps(_ref17) {
      var limit = _ref17.limit,
          offset = _ref17.offset,
          jobApplicationId = _ref17.jobApplicationId;
      return this.axiosInstance.get(ENDPOINTS.workerJobPositions.conversationSteps, {
        params: {
          job_application_id: jobApplicationId,
          limit: limit,
          offset: offset
        }
      });
    }
  }, {
    key: "createConversationStep",
    value: function createConversationStep(params) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.conversationSteps, _objectSpread({}, params));
    }
  }, {
    key: "updateConversationStep",
    value: function updateConversationStep(params) {
      return this, this.axiosInstance.put("".concat(ENDPOINTS.workerJobPositions.conversationSteps, "/").concat(params.id), _objectSpread({}, params));
    }
  }, {
    key: "deleteConversationStep",
    value: function deleteConversationStep(id) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.workerJobPositions.conversationSteps, "/").concat(id));
    }
  }, {
    key: "getInterestedWorkersCsv",
    value: function getInterestedWorkersCsv(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.jobApplications, "/interested_workers_csv"), {
        params: {
          job_position_id: jobPositionId
        },
        responseType: 'blob'
      });
    }
  }, {
    key: "getProposedWorkersCsv",
    value: function getProposedWorkersCsv(jobPositionId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.jobApplications, "/proposed_workers_csv"), {
        params: {
          job_position_id: jobPositionId
        },
        responseType: 'blob'
      });
    }
  }, {
    key: "fetchKlaaryoConversation",
    value: function fetchKlaaryoConversation(_ref18) {
      var jobApplicationId = _ref18.jobApplicationId;
      return this.axiosInstance.get("".concat(ENDPOINTS.klaaryo.root, "/").concat(jobApplicationId));
    }
  }, {
    key: "updateKlaaryoConversation",
    value: function updateKlaaryoConversation(params) {
      return this.axiosInstance.patch(ENDPOINTS.klaaryo.root, _objectSpread({}, params));
    }
  }, {
    key: "createWorkerPresentation",
    value: function createWorkerPresentation(params) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.workerPresentations, _objectSpread({}, params));
    }
  }, {
    key: "updateWorkerPresentation",
    value: function updateWorkerPresentation(params) {
      return this.axiosInstance.patch(ENDPOINTS.workerJobPositions.workerPresentations, _objectSpread({}, params));
    }
  }, {
    key: "deleteWorkerPresentation",
    value: function deleteWorkerPresentation(id) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.workerJobPositions.workerPresentations, "/").concat(id));
    }
  }, {
    key: "sendUpdatedJobProposalEmails",
    value: function sendUpdatedJobProposalEmails(jobPositionId) {
      return this.axiosInstance.post("".concat(ENDPOINTS.workerJobPositions.root, "/propose/again"), {
        job_position_id: jobPositionId,
        status: 'proposed_and_not_interested'
      });
    } // Worker job_application_complaints

  }, {
    key: "createJobApplicationComplaint",
    value: function createJobApplicationComplaint(params) {
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.jobApplicationComplaints, params);
    }
  }, {
    key: "showJobApplicationComplaint",
    value: function showJobApplicationComplaint(id) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.jobApplicationComplaints, "/").concat(id));
    }
  }, {
    key: "updateJobApplicationComplaint",
    value: function updateJobApplicationComplaint(id, params) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.workerJobPositions.jobApplicationComplaints, "/").concat(id), params);
    }
  }, {
    key: "runEvaluation",
    value: function runEvaluation(worker_id, job_position_id) {
      return this.axiosInstance.post("".concat(ENDPOINTS.workerJobPositions.candidateEvaluations, "/run"), {
        worker_id: worker_id,
        job_position_id: job_position_id
      });
    }
  }, {
    key: "updateEvaluation",
    value: function updateEvaluation(worker_id, job_position_id, params) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.workerJobPositions.candidateEvaluations, "/"), _objectSpread({
        worker_id: worker_id,
        job_position_id: job_position_id
      }, params));
    }
  }, {
    key: "getJobApplicationsCountPerCategory",
    value: function getJobApplicationsCountPerCategory(_ref19) {
      var jobPositionId = _ref19.jobPositionId;
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.jobApplications, "/count"), {
        params: {
          job_position_id: jobPositionId,
          category: 'job_applications_tab_LAB'
        }
      });
    } // Assessment Conversations API

  }, {
    key: "listAssessmentsForWorker",
    value: function listAssessmentsForWorker(_ref20) {
      var workerId = _ref20.workerId,
          _ref20$limit = _ref20.limit,
          limit = _ref20$limit === void 0 ? 20 : _ref20$limit,
          _ref20$offset = _ref20.offset,
          offset = _ref20$offset === void 0 ? 0 : _ref20$offset;
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.assessmentsWorker, "/").concat(workerId), {
        params: {
          limit: limit,
          offset: offset
        }
      });
    }
  }, {
    key: "showAssessmentConversation",
    value: function showAssessmentConversation(_ref21) {
      var jobApplicationId = _ref21.jobApplicationId;
      return this.axiosInstance.get("".concat(ENDPOINTS.workerJobPositions.assessmentsConversation, "/").concat(jobApplicationId));
    }
  }, {
    key: "updateAssessmentConversation",
    value: function updateAssessmentConversation(_ref22) {
      var jobApplicationId = _ref22.jobApplicationId,
          managed_by_rw_member_id = _ref22.managed_by_rw_member_id;
      return this.axiosInstance.patch("".concat(ENDPOINTS.workerJobPositions.assessmentsConversation, "/").concat(jobApplicationId), {
        managed_by_rw_member_id: managed_by_rw_member_id
      });
    }
  }, {
    key: "resetAssessmentConversation",
    value: function resetAssessmentConversation(jobApplicationId) {
      return this.axiosInstance.post('/klaaryo/reset_assessment', {
        job_application_id: jobApplicationId
      });
    }
  }, {
    key: "sendManualAssessmentMessage",
    value: function sendManualAssessmentMessage(_ref23) {
      var jobApplicationId = _ref23.jobApplicationId,
          message = _ref23.message,
          template = _ref23.template;
      return this.axiosInstance.post("".concat(ENDPOINTS.workerJobPositions.sendManualAssessmentMessage, "/").concat(jobApplicationId, "/send_message"), {
        message: message,
        template: template
      });
    }
  }]);

  return ServiceWorkerJobPositions;
}(Service);

export function useWorkerJobPositionsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceWorkerJobPositions(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useWorkerJobPositionsService;
export * from './types';